var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotasIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.939941 6.591H6.95172V0.579224L0.939941 6.591Z",
    fill: "#404041"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5807 7.97132L19.7843 10.7676L18.7444 11.8074L18.3861 12.1657L18.156 12.3959V0H8.92879V8.5682H0.360596V24.3864H7.6106V29H13.6692L24.4448 18.2244L25.8429 16.8263L28.6392 14.0301L22.5807 7.97132ZM19.7843 13.5639L20.7164 14.496L10.9997 24.2127L10.0676 23.2807L19.7843 13.5639ZM5.30379 10.5455H13.2129V12.5227H5.30379V10.5455ZM5.30379 14.5H13.2129V16.4773H5.30379V14.5ZM7.94013 20.4318H5.30379V18.4545H7.94013V20.4318ZM9.58786 27.0227V25.5971L11.0135 27.0227H9.58786ZM13.33 26.543L12.3979 25.6109L22.1147 15.8941L23.0468 16.8262L13.33 26.543ZM24.4448 15.4281L21.1824 12.1657L22.5805 10.7676L25.8428 14.0299L24.4448 15.4281Z",
    fill: "#404041"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotasIcon);
export default __webpack_public_path__ + "static/media/notasIcon.34f1d4c030f6e62d7ad68d735681fa47.svg";
export { ForwardRef as ReactComponent };